import React from "react";
import { Message } from "semantic-ui-react";

const PortalMessage = ({
  showSuccessMes,
  setShowSuccessMes,
  showFailMes,
  setShowFailMes,
}) => {
  if (showSuccessMes) {
    return (
      <Message
        positive
        onDismiss={() => setShowSuccessMes(false)}
        content={showSuccessMes}
      />
    );
  }
  if (showFailMes) {
    return (
      <Message
        negative
        onDismiss={() => setShowFailMes(false)}
        content={showFailMes}
      />
    );
  }
  return null;
};

export { PortalMessage };
